'use client';
import {useParams} from 'next/navigation';
import {DEFAULT_LOCALE, isLocale, type Locale} from './locale';

export function useLocale(): Locale {
  const {locale} = useParams<{locale: string}>();
  return locale && isLocale(locale) ? locale : DEFAULT_LOCALE;
}
